<div class="ng-scope">
    <nav class="navbar navbar-expand-lg navbar-light">
        <a class="navbar-brand" href="#">Vendor Info</a>
    </nav>

    <div class="col-sm-12">
        <div class="container-fluid" style="margin-bottom: 1em; padding-left: 0; padding-right: 0;">
            <form class="example-form">
                <div class="card">
                    <div class="card-header">
                        <button class="btn ng-binding" style="float: right;" (click)="toggle()">
                            {{buttonName}}
                        </button>
                    </div>

                    <div class="card-body animate-show-hide" id="filterGroup" *ngIf="ShowFilters">
                        <div class="row">
                            <div class="col-sm-2">
                                <b>
                                    Customer
                                </b>
                            </div>

                            <div class="col-sm-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>select</mat-label>
                                    <mat-select>
                                        <mat-option *ngFor="let cust of custs" [value]="cust.value">
                                            {{cust.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2">
                                <b>
                                    Internal Vendor Id
                                </b>
                            </div>

                            <div class="col-sm-4">
                                <mat-form-field appearance="fill">
                                    <input matInput type="text" name="vendor" id="vendor">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row" style="margin-top: 0.5em;">
                            <div class="col-sm-2">
                                <b>
                                    External Vendor Id
                                </b>
                            </div>
                            <div class="col-sm-4">
                                <mat-form-field appearance="fill">
                                    <input matInput type="text" name="vendor" id="vendor">
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2">
                                <b>
                                    Vendor Name
                                </b>
                            </div>
                            <div class="col-sm-4">
                                <mat-form-field appearance="fill">
                                    <input matInput type="text" name="vendor" id="vendor">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row" style="margin-top: 0.5em;">
                            <div class="col-sm-2">
                                <b>
                                    Payable Status
                                </b>
                            </div>
                            <div class="col-sm-10">
                                <mat-form-field appearance="fill">
                                    <mat-label>select</mat-label>
                                    <mat-select>
                                        <mat-option *ngFor="let sts of status" [value]="sts.value">
                                            {{sts.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                *Only Applicable on Vendors Registered after 01/09/2019
                            </div>
                        </div>

                        <div class="row" style="margin-top: 1em;">
                            <div class="col-sm-2">
                                <button ng-click="$ctrl.searchClicked()" type="button" class="btn btn-primary">
                                    SEARCH
                                </button>
                            </div>

                            <div class="col-sm-8">
                                &nbsp;
                            </div>
                            <div class="col-sm-2">
                                <button ng-click="$ctrl.clearFilters()" type="button" class="btn" style="float: right;">
                                    CLEAR FILTERS
                                </button>
                            </div>
                        </div>
                    </div>
                </div>